import { Record } from "immutable"

import { updateCreateModel } from "../model-utils"

export const ClusterFilterModel = new Record({
    title: ""
})

const tagFields = []

export const updateClusterSearchFilterModel = (
    name,
    value,
    searchFilterModel,
    workingFilterModel
) =>
    updateCreateModel(
        name,
        value,
        searchFilterModel,
        workingFilterModel,
        tagFields
    )
